'use client';

import Image from 'next/image';
import { useRouter } from 'next/navigation';
import React from 'react';

import { Button } from './ui/button';

type BackButtonProps = {
  onClick?: () => void;
};

function BackButton({ onClick }: BackButtonProps) {
  const router = useRouter();

  return (
    <Button
      size="icon"
      variant="outline"
      onClick={onClick ?? (() => router.back())}
      className="rounded-full"
    >
      <Image
        src="/assets/svgs/Icons/ArrowLeft.svg"
        alt="Logo"
        width={16}
        height={16}
        className="min-h-6 "
      />
    </Button>
  );
}

export default BackButton;
